import React, { memo } from "react";

const TrashIcon: React.FC = memo(() => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="TrashIcon"
    >
      <path
        d="M5.33333 0.5V1.38889H1V3.16667H1.86667V14.7222C1.86667 15.1937 2.04929 15.6459 2.37435 15.9793C2.69941 16.3127 3.14029 16.5 3.6 16.5H12.2667C12.7264 16.5 13.1673 16.3127 13.4923 15.9793C13.8174 15.6459 14 15.1937 14 14.7222V3.16667H14.8667V1.38889H10.5333V0.5H5.33333ZM5.33333 4.94444H7.06667V12.9444H5.33333V4.94444ZM8.8 4.94444H10.5333V12.9444H8.8V4.94444Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { TrashIcon };
